import { QueryObjectsModel } from '@barthauer/abc/core/data';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { GroupSelectionComponent } from './group-selection/group-selection.component';
import { ObjectSelectionComponent } from './object-selection/object-selection.component';
export class GroupSelectionService {
  private resAsync: Promise<ResourceSet>;
  public res: ResourceSet = ResourceSet.Empty;
  public groupComponent!: GroupSelectionComponent;
  public currentObjectType: string | number;
  public query: QueryObjectsModel;

  private _objectSelectionComponents = new Map<string, ObjectSelectionComponent>();

  public get objectSelectionComponents(): Map<string, ObjectSelectionComponent> {
    return this._objectSelectionComponents;
  }

  constructor(private resourceManagerService: ResourceManagerService) {
    this.resAsync = this.resourceManagerService.getResourceSet('abc-ui-frameworks-object-selection');
    this.resAsync.then((resourceSet) => (this.res = resourceSet));
  }

  public getIdOrOtExprName(key: string): string | undefined {
    return this.query.ObjectQueries[0].Columns.find((c) => c.Name === key || c.OPath === key)?.Name;
  }
}
